export default __webpack_public_path__ + "static/media/karoq.b2e328de.jpg";